export const routes = {
  home: "/",
  browse: {
    index: "/browse",
    detail: {
      objects: "/browse/objects/:id",
      places: "/browse/places/:id",
      people: "/browse/people/:id",
      groups: "/browse/groups/:id",
      events: "/browse/events/:id",
    },
  },
  galleries: "/galleries",
  project: "/project",
  error: {
    index: "*",
  },
};

export const apiRoutes = {};
